
/**
 * SPIKOMOTORS JS v3.1
 * Vanilla only. No frameworks.
 *
 * Mobile Navigation wird ausschliesslich
 * in sections/sm-header.liquid gesteuert.
 */

(function () {
  'use strict';

  /* --- Header scroll effect --- */
  function initHeader() {
    var hdr = document.getElementById('sm-hdr');
    if (!hdr) return;

    function check() {
      hdr.classList.toggle('scrolled', window.scrollY > 45);
    }

    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  /* --- Scroll animations --- */
  function initAnims() {
    var els = document.querySelectorAll('.sm-anim');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) {
        e.classList.add('visible');
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          io.unobserve(e.target);
        }
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -28px 0px'
    });

    els.forEach(function (el, i) {
      el.style.animationDelay = (i * 0.055) + 's';
      io.observe(el);
    });
  }

  /* --- Hero scroll indicator hide --- */
  function initHeroScroll() {
    var ind = document.querySelector('.sm-hero__scroll');
    if (!ind) return;

    window.addEventListener('scroll', function () {
      ind.classList.toggle('hidden', window.scrollY > 90);
    }, { passive: true });
  }

  /* --- FAQ accordion --- */
  function initFaq() {
    document.querySelectorAll('.sm-faq-item').forEach(function (item) {
      var btn = item.querySelector('.sm-faq-q');
      if (!btn) return;

      btn.addEventListener('click', function () {
        var open = item.classList.contains('open');
        var parent = item.closest('.sm-faq');

        if (parent) {
          parent.querySelectorAll('.sm-faq-item.open').forEach(function (o) {
            if (o !== item) {
              o.classList.remove('open');
            }
          });
        }

        item.classList.toggle('open', !open);
      });
    });
  }

  /* --- Vehicle filter --- */
  function initFilter() {
    var btns = document.querySelectorAll('[data-vf]');
    if (!btns.length) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) {
          b.classList.remove('active');
        });

        btn.classList.add('active');

        var f = btn.dataset.vf;

        document.querySelectorAll('[data-vc]').forEach(function (card) {
          var show = f === 'all' || card.dataset.vc === f;
          card.style.display = show ? '' : 'none';
        });
      });
    });
  }

  /* --- FAQ category filter --- */
  function initFaqFilter() {
    var btns = document.querySelectorAll('[data-ff]');
    if (!btns.length) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) {
          b.classList.remove('active');
        });

        btn.classList.add('active');

        var f = btn.dataset.ff;

        document.querySelectorAll('[data-fc]').forEach(function (item) {
          item.style.display =
            (f === 'all' || item.dataset.fc === f) ? '' : 'none';
        });
      });
    });
  }

  /* --- Smooth anchors --- */
  function initAnchors() {
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var href = this.getAttribute('href');

        if (!href || href === '#') return;

        var t = document.querySelector(href);
        if (!t) return;

        e.preventDefault();

        window.scrollTo({
          top: t.getBoundingClientRect().top + window.scrollY - 80,
          behavior: 'smooth'
        });
      });
    });
  }

  /* --- Probefahrt vehicle preselect from URL --- */
  function initProbePreselect() {
    var v = new URLSearchParams(window.location.search).get('vehicle');
    if (!v) return;

    var s = document.querySelector('#probe-vehicle');
    if (!s) return;

    Array.from(s.options).forEach(function (o) {
      if (o.value.toLowerCase().includes(v.toLowerCase())) {
        o.selected = true;
      }
    });
  }

  /* --- Contact form --- */
  function initForms() {
    document.querySelectorAll('.sm-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var btn = form.querySelector('[type=submit]');
        var valid = true;

        if (!btn) return;

        form.querySelectorAll('[required]').forEach(function (f) {
          if (!f.value.trim()) {
            f.style.borderColor = '#e24b4a';
            valid = false;
          } else {
            f.style.borderColor = '';
          }
        });

        if (!valid) return;

        var orig = btn.textContent;
        btn.textContent = 'Wird gesendet…';
        btn.disabled = true;

        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(function (r) {
          if (r.ok) {
            formOk(form);
          } else {
            formErr(form, btn, orig);
          }
        })
        .catch(function () {
          formErr(form, btn, orig);
        });
      });
    });
  }

  function formOk(f) {
    var s = f.querySelector('.sm-form-ok');

    if (s) {
      f.style.display = 'none';
      s.style.display = 'block';
    } else {
      f.innerHTML =
        '<p style="color:#4ade80;padding:2rem 0">' +
        '✓ Gesendet. Wir melden uns bald.' +
        '</p>';
    }
  }

  function formErr(f, b, t) {
    b.textContent = t;
    b.disabled = false;
  }

  /* --- Init --- */
  function init() {
    initHeader();
    initAnims();
    initHeroScroll();
    initFaq();
    initFilter();
    initFaqFilter();
    initAnchors();
    initProbePreselect();
    initForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
